import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import ImageWithFallback from '@liveauctioneers/caterwaul-components/lib/ImageWithFallback/ImageWithFallback2';
import styled from 'styled-components';
import TrustBoxWidget from '@/components/TrustBox/TrustBoxWidget';

const Trust = () => {
    return (
        <StyledTrust>
            <StyledTrustContainer>
                <StyledAffiliates>
                    <StyledTitle>
                        <FormattedMessage id="as_seen_on" />
                    </StyledTitle>
                    <StyledAffiliateContent>
                        <StyledNBCContainer>
                            <StyledSVGImage
                                alt="NBC"
                                height="43"
                                lazy
                                src="https://p1.liveauctioneers.com/dist/images/NBC.svg"
                                width="44"
                            />
                        </StyledNBCContainer>
                        <StyledABCContainer>
                            <StyledSVGImage
                                alt="ABC"
                                height="38"
                                lazy
                                src="https://p1.liveauctioneers.com/dist/images/ABC.svg"
                                width="38"
                            />
                        </StyledABCContainer>
                        <StyledTodayContainer>
                            <StyledSVGImage
                                alt="Today"
                                height="42"
                                lazy
                                src="https://p1.liveauctioneers.com/dist/images/TODAY.svg"
                                width="57"
                            />
                        </StyledTodayContainer>
                        <StyledChicagoTribuneContainer>
                            <StyledSVGImage
                                alt="Chicago Tribune"
                                height="20"
                                lazy
                                src="https://p1.liveauctioneers.com/dist/images/ChicagoTribune.svg"
                                width="137"
                            />
                        </StyledChicagoTribuneContainer>
                        <StyledArchitecturalDigestContainer>
                            <StyledSVGImage
                                alt="Architectural Digest"
                                height="14"
                                lazy
                                src="https://p1.liveauctioneers.com/dist/images/ArchDigest.svg"
                                width="162"
                            />
                        </StyledArchitecturalDigestContainer>
                    </StyledAffiliateContent>
                </StyledAffiliates>
                <StyledSeparator />
                <StyledConfidence>
                    <StyledTitle>
                        <FormattedMessage id="shop_with_confidence" />
                    </StyledTitle>
                    <StyledTrustContent>
                        <FormattedMessage id="since_2002_liveauctioneers_has_made_items" />
                    </StyledTrustContent>
                    <StyledTrustContent>
                        <StyledTrustBox />
                        <a
                            href="http://www.bbb.org/new-york-city/business-reviews/internet-auction-service/live-auctioneers-llc-in-new-york-ny-123530/#bbbonlineclick"
                            rel="nofollow noopener"
                            target="_blank"
                        >
                            <StyledBetterBusinessReview
                                alt="LiveAuctioneers LLC BBB Business Review"
                                height="52"
                                lazy
                                src="https://p1.liveauctioneers.com/seals/blue-seal-250-52-bbb-123530.png"
                                width="250"
                            />
                        </a>
                    </StyledTrustContent>
                </StyledConfidence>
            </StyledTrustContainer>
        </StyledTrust>
    );
};

export default React.memo(Trust);

const StyledTrust = styled.div`
    display: flex;
    justify-content: center;
`;

const StyledTrustContainer = styled.div`
    background-color: ${({ theme }) => theme.colors.white};
    display: flex;
    justify-content: center;
    padding: 30px 20px 0;
    max-width: ${({ theme }) => theme.breakpoints.pageWidth};

    @media (max-width: ${({ theme }) => `${theme.breakpoints.tabletWidthNum + 1}px`}) {
        flex-direction: column;
    }
`;
const StyledAffiliates = styled.div`
    width: 45%;

    @media (max-width: ${({ theme }) => `${theme.breakpoints.tabletWidthNum + 1}px`}) {
        width: auto;
        margin: 0 10px;
    }
`;
const StyledTitle = styled.div`
    margin-bottom: 10px;
    font-size: 14px;
    font-family: ${({ theme }) => theme.typography.fontPrimaryStrong};
    color: ${({ theme }) => theme.colors.grey100};
`;

const StyledAffiliateContent = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 33px;

    @media (max-width: ${({ theme }) => `${theme.breakpoints.tabletWidthNum + 1}px`}) {
        justify-content: center;

        div {
            margin: 0 20px 20px 20px;
        }
    }
`;
const StyledNBCContainer = styled.div`
    position: relative;
    height: 43px;
    width: 44px;
`;

const StyledABCContainer = styled.div`
    position: relative;
    height: 38px;
    width: 38px;
`;

const StyledTodayContainer = styled.div`
    position: relative;
    height: 42px;
    width: 57px;
`;

const StyledChicagoTribuneContainer = styled.div`
    position: relative;
    height: 20px;
    width: 137px;
`;

const StyledArchitecturalDigestContainer = styled.div`
    position: relative;
    height: 14px;
    width: 162px;
`;

const StyledSVGImage = styled(ImageWithFallback)`
    max-height: 100%;
    max-width: 100%;
`;

const StyledSeparator = styled.div`
    display: none;
    background-color: ${({ theme }) => theme.colors.grey400};
    height: 1px;
    padding: 0 0.5em;

    @media (max-width: ${({ theme }) => `${theme.breakpoints.tabletWidthNum + 1}px`}) {
        margin-left: 1.5em;
        margin-right: 1.5em;
        margin-top: 40px;
        display: inline;
    }
`;

const StyledConfidence = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    height: 150px;
    margin-left: 60px;
    position: relative;
    width: 54%;

    @media (max-width: ${({ theme }) => `${theme.breakpoints.tabletWidthNum + 1}px`}) {
        width: auto;
        height: auto;
        margin-left: 10px;
        margin-top: 20px;
        margin-bottom: 40px;
    }
`;

const StyledTrustContent = styled.div`
    color: ${({ theme }) => theme.colors.grey100};
    font-weight: normal;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-right: 20px;
    margin-top: 18px;
    width: 48%;

    @media (max-width: ${({ theme }) => `${theme.breakpoints.tabletWidthNum + 1}px`}) {
        width: auto;
        margin-left: 20px;
        justify-content: center;
    }
`;

const StyledTrustBox = styled(TrustBoxWidget)`
    @media (max-width: ${({ theme }) => `${theme.breakpoints.tabletWidthNum + 1}px`}) {
        margin-right: 20px;
    }
`;

const StyledBetterBusinessReview = styled(ImageWithFallback)`
    height: 52px;
    width: 250px;
`;
